import P2Regular from 'components/typography/P2Regular';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the revision name.
 */
export default function RevisionNameColumn({ data: { revisionName } }: { data: RevisionRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {revisionName}
    </P2Regular>
  );
}
